// Mock data for DivinArte storefront (frontend-only)
// All copy in Portuguese (Portugal). Wellness-compliant language.

export const categories = [
  {
    slug: "faciais",
    name: "Faciais",
    description: "Rituais de cuidado para o rosto, com fórmulas suaves e botânicas.",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1400&q=70",
    subcategories: [
      { slug: "cremes-faciais", name: "Cremes faciais" },
      { slug: "seruns", name: "Séruns" },
      { slug: "aguas-florais", name: "Águas florais" },
    ],
  },
  {
    slug: "corporais",
    name: "Corporais",
    description: "Manteigas, esfoliantes e óleos que nutrem profundamente.",
    image: "https://images.unsplash.com/photo-1570194065650-d99fb4bedf0a?auto=format&fit=crop&w=1400&q=70",
    subcategories: [
      { slug: "manteigas", name: "Manteigas corporais" },
      { slug: "esfoliantes", name: "Esfoliantes" },
      { slug: "oleos", name: "Óleos corporais" },
    ],
  },
  {
    slug: "capilares",
    name: "Capilares",
    description: "Cuidado capilar artesanal de raiz natural.",
    image: "https://images.unsplash.com/photo-1631730486572-226d1f595b68?auto=format&fit=crop&w=1400&q=70",
    subcategories: [
      { slug: "champos", name: "Champôs sólidos" },
      { slug: "mascaras", name: "Máscaras" },
    ],
  },
  {
    slug: "bem-estar",
    name: "Bem-estar / Aromaterapia",
    description: "Sprays, bálsamos e roll-ons para momentos de pausa e cuidado.",
    image: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?auto=format&fit=crop&w=1400&q=70",
    subcategories: [
      { slug: "sprays", name: "Sprays aromáticos" },
      { slug: "balsamos", name: "Bálsamos" },
      { slug: "roll-ons", name: "Roll-ons" },
    ],
  },
];

const img = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=70`;

export const products = [
  {
    id: "p01", slug: "spray-sono-ansiedade",
    name: "Spray Sono e Ansiedade",
    short: "Auxilia no relaxamento e numa noite mais serena.",
    price: 18.9, category: "bem-estar", sub: "sprays",
    skinType: ["todos"], purpose: ["relaxamento"], vegan: true, bio: true,
    size: "100ml",
    images: [img("photo-1608571423902-eed4a5ad8108"), img("photo-1571781926291-c477ebfd024b"), img("photo-1556228852-80b6e5eeff06")],
    benefits: ["Promove uma sensação de calma", "Notas florais suaves de lavanda e camomila", "Ideal para a almofada e ambiente"],
    usage: "Borrifar sobre a almofada ou no ar do quarto, 15 minutos antes de deitar. Agitar antes de usar.",
    description: "Uma fórmula floral pensada para acompanhar momentos de pausa, com lavanda dos Alpes e camomila romana. Auxilia no relaxamento e prepara o corpo e a mente para o descanso.",
    isNew: true,
  },
  {
    id: "p02", slug: "spray-concentracao-mindfulness",
    name: "Spray Concentração / Mindfulness",
    short: "Frescura herbal que acompanha momentos de foco.",
    price: 18.9, category: "bem-estar", sub: "sprays",
    skinType: ["todos"], purpose: ["foco"], vegan: true, bio: true,
    size: "100ml",
    images: [img("photo-1571781926291-c477ebfd024b"), img("photo-1556228720-195a672e8a03")],
    benefits: ["Notas de hortelã, alecrim e eucalipto", "Promove sensação de clareza", "Acompanha rituais de respiração"],
    usage: "Borrifar no ar antes de momentos de estudo, meditação ou trabalho focado.",
    description: "Uma composição herbal viva, com hortelã-pimenta, alecrim e eucalipto, criada para acompanhar momentos de foco e respiração consciente.",
    isNew: true,
  },
  {
    id: "p03", slug: "balsamo-analgesico",
    name: "Bálsamo Analgésico",
    short: "Sensação de alívio e conforto muscular.",
    price: 22.5, category: "bem-estar", sub: "balsamos",
    skinType: ["todos"], purpose: ["conforto"], vegan: false, bio: true,
    size: "50ml",
    images: [img("photo-1556228720-195a672e8a03"), img("photo-1608571423902-eed4a5ad8108")],
    benefits: ["Cera de abelha e óleos botânicos", "Sensação de calor reconfortante", "Para usar após esforço físico"],
    usage: "Aplicar com massagem circular nas zonas pretendidas. Evitar contacto com olhos e mucosas.",
    description: "Um bálsamo denso, com cera de abelha pura e óleos essenciais de hortelã, gaultéria e cânfora, para momentos de conforto após o esforço.",
  },
  {
    id: "p04", slug: "manteiga-corporal-vegana",
    name: "Manteiga Corporal Vegana",
    short: "Hidrata profundamente, sem aroma artificial.",
    price: 24.0, category: "corporais", sub: "manteigas",
    skinType: ["seca", "sensivel"], purpose: ["hidratacao"], vegan: true, bio: true,
    size: "100ml",
    images: [img("photo-1570194065650-d99fb4bedf0a"), img("photo-1556228720-195a672e8a03")],
    benefits: ["Manteiga de karité e murumuru", "Textura aveludada", "Hidratação prolongada"],
    usage: "Aplicar diariamente sobre a pele seca ou ligeiramente húmida, com massagem suave.",
    description: "Uma manteiga rica em karité bio e óleo de murumuru, que envolve a pele numa hidratação profunda e prolongada.",
  },
  {
    id: "p05", slug: "champo-solido-fortalecedor",
    name: "Champô Sólido Fortalecedor",
    short: "Cuida do couro cabeludo e dá corpo ao cabelo.",
    price: 15.0, category: "capilares", sub: "champos",
    skinType: ["todos"], purpose: ["fortalecimento"], vegan: true, bio: true,
    size: "70g",
    images: [img("photo-1631730486572-226d1f595b68"), img("photo-1556228720-195a672e8a03")],
    benefits: ["Sem sulfatos agressivos", "Argila branca e rhassoul", "Aroma fresco de citrinos"],
    usage: "Passar o sabonete diretamente no cabelo molhado e massajar com as mãos. Enxaguar bem.",
    description: "Um champô sólido artesanal com argilas naturais e óleos essenciais de bergamota e laranja-doce.",
  },
  {
    id: "p06", slug: "creme-facial-calming",
    name: "Creme Facial Calmante",
    short: "Conforto imediato para peles reativas.",
    price: 29.9, category: "faciais", sub: "cremes-faciais",
    skinType: ["sensivel", "seca"], purpose: ["calmante"], vegan: true, bio: true,
    size: "50ml",
    images: [img("photo-1556228720-195a672e8a03"), img("photo-1570194065650-d99fb4bedf0a")],
    benefits: ["Extrato de calêndula e aveia coloidal", "Textura leve e absorção rápida", "Reduz a sensação de pele tensa"],
    usage: "Aplicar de manhã e à noite sobre o rosto e pescoço limpos, com toques suaves.",
    description: "Uma fórmula calmante com calêndula bio e aveia coloidal, formulada para devolver conforto às peles mais sensíveis.",
    isNew: true,
  },
  {
    id: "p07", slug: "serum-facial-revigorante",
    name: "Sérum Facial Revigorante",
    short: "Luminosidade e viço, dia após dia.",
    price: 34.5, category: "faciais", sub: "seruns",
    skinType: ["todos"], purpose: ["luminosidade"], vegan: true, bio: false,
    size: "30ml",
    images: [img("photo-1571781926291-c477ebfd024b"), img("photo-1556228852-80b6e5eeff06")],
    benefits: ["Vitamina C estabilizada", "Óleo de rosa-mosqueta", "Sensação leve e sedosa"],
    usage: "Aplicar 3-4 gotas de manhã, antes do creme hidratante. Evitar contorno dos olhos.",
    description: "Um sérum que combina vitamina C e rosa-mosqueta para promover uma pele mais luminosa e uniforme.",
  },
  {
    id: "p08", slug: "agua-floral-rosa",
    name: "Água Floral de Rosa",
    short: "Toque suave de frescura e equilíbrio.",
    price: 16.0, category: "faciais", sub: "aguas-florais",
    skinType: ["todos"], purpose: ["tonificante"], vegan: true, bio: true,
    size: "150ml",
    images: [img("photo-1556228852-80b6e5eeff06"), img("photo-1570194065650-d99fb4bedf0a")],
    benefits: ["100% hidrolato de rosa damascena", "Tonifica e refresca", "Pode ser usada como bruma"],
    usage: "Borrifar no rosto após a limpeza ou ao longo do dia para uma sensação de frescura.",
    description: "Um hidrolato puro de rosa damascena, obtido por destilação a vapor — um clássico botânico.",
  },
  {
    id: "p09", slug: "oleo-corporal-flora-cedro",
    name: "Óleo Corporal Flora & Cedro",
    short: "Pele nutrida, com toque seco e aroma quente.",
    price: 26.5, category: "corporais", sub: "oleos",
    skinType: ["todos"], purpose: ["nutricao"], vegan: true, bio: false,
    size: "100ml",
    images: [img("photo-1608571423902-eed4a5ad8108"), img("photo-1570194065650-d99fb4bedf0a")],
    benefits: ["Óleos de jojoba, amêndoa e abacate", "Aroma de cedro e baunilha", "Toque seco e elegante"],
    usage: "Aplicar com massagem suave após o banho, com a pele ligeiramente húmida.",
    description: "Um óleo corporal multi-uso, com aroma envolvente de cedro e baunilha-bourbon.",
  },
  {
    id: "p10", slug: "esfoliante-corporal-cafe",
    name: "Esfoliante Corporal de Café",
    short: "Pele macia e sentidos despertos.",
    price: 19.0, category: "corporais", sub: "esfoliantes",
    skinType: ["todos"], purpose: ["renovacao"], vegan: true, bio: false,
    size: "200g",
    images: [img("photo-1570194065650-d99fb4bedf0a"), img("photo-1556228720-195a672e8a03")],
    benefits: ["Café arábica moído", "Óleo de coco e açúcar mascavado", "Promove pele renovada"],
    usage: "Aplicar com massagem circular sobre a pele húmida. Enxaguar e secar.",
    description: "Um esfoliante artesanal com café arábica, açúcar mascavado e óleo de coco para uma pele macia e renovada.",
  },
  {
    id: "p11", slug: "mascara-capilar-argan",
    name: "Máscara Capilar Argan",
    short: "Reparação intensa para cabelos secos.",
    price: 23.0, category: "capilares", sub: "mascaras",
    skinType: ["todos"], purpose: ["reparacao"], vegan: true, bio: false,
    size: "150ml",
    images: [img("photo-1631730486572-226d1f595b68"), img("photo-1571781926291-c477ebfd024b")],
    benefits: ["Óleo de argan puro", "Manteiga de cacau", "Devolve brilho e maciez"],
    usage: "Aplicar nos comprimentos e pontas após a lavagem. Deixar atuar 5-10 minutos e enxaguar.",
    description: "Uma máscara rica em argan e cacau, criada para devolver brilho a cabelos secos ou trabalhados.",
  },
  {
    id: "p12", slug: "roll-on-respiracao",
    name: "Roll-on Respiração",
    short: "Pequeno gesto, grande pausa.",
    price: 12.0, category: "bem-estar", sub: "roll-ons",
    skinType: ["todos"], purpose: ["respiracao"], vegan: true, bio: true,
    size: "10ml",
    images: [img("photo-1556228852-80b6e5eeff06"), img("photo-1608571423902-eed4a5ad8108")],
    benefits: ["Eucalipto e menta", "Formato bolso", "Para momentos de pausa"],
    usage: "Aplicar nos pulsos e nas têmporas e respirar fundo durante alguns segundos.",
    description: "Um pequeno roll-on com base em jojoba e óleos essenciais de eucalipto e menta, para acompanhar o teu dia.",
  },
  {
    id: "p13", slug: "creme-facial-noite",
    name: "Creme Facial de Noite",
    short: "Repouso e reconforto enquanto dormes.",
    price: 32.0, category: "faciais", sub: "cremes-faciais",
    skinType: ["seca"], purpose: ["nutricao"], vegan: true, bio: true,
    size: "50ml",
    images: [img("photo-1570194065650-d99fb4bedf0a"), img("photo-1556228720-195a672e8a03")],
    benefits: ["Manteiga de cupuaçu", "Ácido hialurónico vegetal", "Pele nutrida ao acordar"],
    usage: "Aplicar à noite, sobre o rosto limpo, com toques suaves.",
    description: "Uma fórmula rica de noite com cupuaçu e ácido hialurónico vegetal, para uma pele nutrida ao acordar.",
  },
  {
    id: "p14", slug: "balsamo-labial-mel",
    name: "Bálsamo Labial Mel",
    short: "Conforto e brilho subtil.",
    price: 8.5, category: "corporais", sub: "manteigas",
    skinType: ["todos"], purpose: ["hidratacao"], vegan: false, bio: true,
    size: "15ml",
    images: [img("photo-1556228720-195a672e8a03"), img("photo-1608571423902-eed4a5ad8108")],
    benefits: ["Mel de produtor local", "Cera de abelha", "Brilho suave"],
    usage: "Aplicar nos lábios sempre que sentir necessidade.",
    description: "Um bálsamo simples e nutritivo, com mel de produtor local e cera de abelha.",
  },
  {
    id: "p15", slug: "spray-ambiente-cedro-laranja",
    name: "Spray Ambiente Cedro & Laranja",
    short: "Aroma quente que envolve a casa.",
    price: 21.0, category: "bem-estar", sub: "sprays",
    skinType: ["todos"], purpose: ["ambiente"], vegan: true, bio: true,
    size: "100ml",
    images: [img("photo-1571781926291-c477ebfd024b"), img("photo-1556228852-80b6e5eeff06")],
    benefits: ["Cedro do Atlas e laranja-doce", "Sem álcool sintético", "Para sala, quarto e têxteis"],
    usage: "Borrifar no ar ou sobre os têxteis a uma distância de 30 cm.",
    description: "Um spray ambiente quente, com cedro do Atlas e laranja-doce, para envolver a casa numa pausa serena.",
  },
  {
    id: "p16", slug: "champo-liquido-suave",
    name: "Champô Líquido Suave",
    short: "Limpeza delicada para uso frequente.",
    price: 17.5, category: "capilares", sub: "champos",
    skinType: ["sensivel"], purpose: ["limpeza"], vegan: true, bio: true,
    size: "250ml",
    images: [img("photo-1631730486572-226d1f595b68"), img("photo-1570194065650-d99fb4bedf0a")],
    benefits: ["Tensioativos suaves", "Aloé vera e camomila", "Para couro cabeludo sensível"],
    usage: "Aplicar no cabelo molhado, massajar e enxaguar. Repetir se necessário.",
    description: "Um champô líquido suave, formulado com aloé vera e camomila para limpezas frequentes e delicadas.",
  },
];

export const blogPosts = [
  {
    slug: "ritual-de-noite-3-passos",
    title: "O ritual de noite em 3 passos",
    excerpt: "Pequenos gestos que preparam o corpo e a mente para o descanso.",
    category: "Rituais",
    date: "2025-10-12",
    cover: "https://images.unsplash.com/photo-1556228852-80b6e5eeff06?auto=format&fit=crop&w=1400&q=70",
    author: "Equipa DivinArte",
    body: "<p>Há noites em que basta acender uma luz quente, respirar fundo e aplicar um gesto de cuidado para o corpo entender que é hora de abrandar. Neste artigo partilhamos um ritual simples — em três passos — que pode acompanhar-te todas as noites.</p><h2>1. Prepara o ambiente</h2><p>Luz suave, telefone longe, um momento só teu. Estes pequenos momentos não exigem grandes preparativos — bastam alguns minutos e a vontade de pausar.</p><h2>2. O gesto de cuidado</h2><p>Aplica o Spray Sono e Ansiedade na almofada e nos pulsos, com respirações lentas e profundas.</p><h2>3. Repete com atenção</h2><ul><li>Mesma hora, todas as noites</li><li>Sem pressa</li><li>Sem expectativas — só o gesto</li></ul><blockquote>Cuidar é a forma mais antiga de bondade.</blockquote><p>Em cada artigo partilhamos uma parte do nosso modo de fazer. Esperamos que aqui encontres inspiração para os teus próprios rituais.</p>",
  },
  {
    slug: "ingredientes-em-foco-rosa-mosqueta",
    title: "Ingredientes em foco: rosa-mosqueta",
    excerpt: "Como este óleo se tornou um clássico da cosmética natural.",
    category: "Ingredientes",
    date: "2025-09-30",
    cover: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1400&q=70",
    author: "Equipa DivinArte",
    body: "<p>A rosa-mosqueta é apreciada pelas suas notas suaves e pela sua textura sedosa. Aqui contamos um pouco da sua origem e da forma como a usamos.</p><h2>De onde vem</h2><p>Extraído das semente da roseira-brava, é um óleo tradicionalmente usado em rituais de cuidado da pele em climas frios e secos.</p><h2>Como o usamos</h2><ul><li>No Sérum Revigorante, combinado com vitamina C</li><li>Em pequenas quantidades, para não pesar na pele</li><li>De preferência à noite, antes de dormir</li></ul><p>Em cada artigo partilhamos uma parte do nosso modo de fazer. Esperamos que aqui encontres inspiração para os teus próprios rituais.</p>",
  },
  {
    slug: "natural-vs-bio-o-que-significa",
    title: "Natural vs BIO: o que significa, afinal?",
    excerpt: "Pequeno guia honesto sobre os termos que aparecem nos rótulos.",
    category: "Saber mais",
    date: "2025-09-15",
    cover: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?auto=format&fit=crop&w=1400&q=70",
    author: "Equipa DivinArte",
    body: "<p>Natural, BIO, vegano… Os rótulos nem sempre dizem o mesmo. Neste artigo damos definições simples para te ajudar a escolher.</p><h2>Natural</h2><p>Ingredientes de origem botânica, sem promessas exageradas — só o essencial.</p><h2>BIO</h2><p>Cultivo sem pesticidas de síntese, com origem certificada.</p><h2>Vegano</h2><p>Sem ingredientes de origem animal, em nenhuma fase do processo.</p><p>Em cada artigo partilhamos uma parte do nosso modo de fazer. Esperamos que aqui encontres inspiração para os teus próprios rituais.</p>",
  },
];

export const testimonials = [
  {
    name: "Mariana C.", city: "Porto",
    text: "O Spray Sono e Ansiedade tornou-se um pequeno ritual antes de dormir. Adoro o aroma e a sensação de pausa.",
  },
  {
    name: "André L.", city: "Lisboa",
    text: "A manteiga corporal é maravilhosa — pele macia o dia inteiro, sem perfume artificial.",
  },
  {
    name: "Sofia M.", city: "Braga",
    text: "Compro o creme facial calmante há meses. A minha pele agradece — e a embalagem é linda.",
  },
];


export const findProduct = (slug) => products.find((p) => p.slug === slug);
export const findCategory = (slug) => categories.find((c) => c.slug === slug);
export const findPost = (slug) => blogPosts.find((b) => b.slug === slug);
